<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {
    Image,
  },
  data() {
    return {
      logisticstype:'物流管理',
      table: {
        mname: "logisticsType",
        key: "id",
        url: {
          del: "/admin/logisticsType/delete",
        },
        output: false,
        order:'id',
        qrCode: "qrCode",
      },
      actions: [
        {
          label: "添加",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "/admin/logisticsType/add",
          type: "info",
        },
      ],
      menus: [
        // { label: "商品管理", name: "commodity_list", auth: "/admin/commodity/list"},
        // { label: "分类管理", name: "commodityType_list", auth: "/admin/commodityType/list"},
        // { label: "标签管理", name: "labelType_list", auth: "/admin/labelType/list"},
        // { label: "日志管理", name: "logType_list", auth: "/admin/logType/list"},
        // { label: "物流管理", name: "logisticsType_list", auth: "/admin/logisticsType/list"},
        // { label: "订单管理", name: "ordersType_list", auth: "/admin/ordersType/list"},
      ],
      query: {
        //state: 2,
      },
      filters: [
      {label: '物流名称', name: 'logisticsType', value: '', type: 'input'},
        // { label: "商品名称", name: "commodityName", value: "", type: "select" },
        // {
        //   label: "标签分类",
        //   name: "commodityType",
        //   value: "",
        //   type: "select",
        //   dropList: [
        //     { value: 1, name: "医用耗材" },
        //     { value: 2, name: "电子设备" },
        //   ],
        // },
      ],
      tableCols: [
        // {
        //   type: "selection",
        //   width: 60,
        // },
        // {
        //   title: "ID",
        //   key: "id",
        //   minWidth: 120,
        //   align: "left",
        // },
        // {
        //   title: "客户ID",
        //   key: "id",
        //   minWidth: 160,
        //   align: "left",
        // },
        {
          title: "物流名称",
          key: "logisticsType",
          minWidth: 100,
          align: "center",
        },
        {
          title: "物流详情",
          key: "logisticsDetail",
          minWidth: 160,

          align: "center",

        },
        {
          title: "物流合作人",
          key: "createBy",
          minWidth: 160,

          align: "center",

        },
        {
          title: "物流合作时间",
          key: "createTime",
          minWidth: 160,

          align: "center",

        },
        {
          title: "操作",
          align: "center",
          width: 260,

          key: "handle",
          handle: [
              "edit",
              "delete"
            ],
            auth: {
              edit: "/admin/logisticsType/edit",
              del: "/admin/logisticsType/delete",
            }
          // render:()=>{
          //     return (            
          //       <Space direction="vertical">
          //         <Space wrap>
          //             <Button>编辑</Button>
          //             <Button type="error" style="margin-left:10px">删除</Button>
          //         </Space>
          //     </Space>
          //     )
          // }
        },
        
       
      ],
    };
  },
  created() {
  },
  methods: {
    //选中
  
    toAdd() {
      $utils.url.push({ name: "logisticsType_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "logisticsType_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
  },
};
</script>

